import { useEffect } from "react";
import Lenis from "lenis";

export function useLenis() {
    useEffect(() => {
        const prefersReducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;

        if (prefersReducedMotion) return;

        const lenis = new Lenis({
            duration: 1.1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.5,
        });

        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);

        // Allow anchor scrolling via Lenis
        const handleAnchor = (e) => {
            const target = e.target.closest('a[href^="#"]');
            if (!target) return;
            const id = target.getAttribute("href").slice(1);
            if (!id) return;
            const el = document.getElementById(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -40 });
            }
        };
        document.addEventListener("click", handleAnchor);

        return () => {
            document.removeEventListener("click", handleAnchor);
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);
}
